import { resetIdentity } from "../utils/analytics"
import { clearImpersonation } from "../utils/impersonation"

export default defineNuxtPlugin(() => {
	if (!import.meta.client) return

	const authChannel = new BroadcastChannel("token")

	authChannel.onmessage = (event) => {
		if (event.data.type === "TOKEN_REFRESHED") {
			useCookie("auth_token").value = event.data.token
		}

		if (event.data.type === "LOGOUT") {
			// Cross-tab logout. Reset here too, or this tab keeps sending events
			// under the logged-out user's identity.
			resetIdentity()
			clearImpersonation()
			useCookie("auth_token").value = null
			navigateTo("/login")
		}
	}
})
